import { useMutation } from '@tanstack/react-query';
import { getErrorMessage } from '@tectonic/errors';
import { Logger } from '@tectonic/logger';
import { requestOtp } from '@tectonic/remix-client-network';
import { ElemasonAuthStep } from '@tectonic/types';
import { useToast } from '../../../core/ElemasonEntry/Toast';
import { useAuthStore } from '../../../store';

import type { ElemasonAuthEmailLinkFormWidget } from '@tectonic/types';
import type { EmailInputFormValue } from '../../../components';

const sendOtp = async (email: string) => {
  const otpResponse = await requestOtp({ email });
  if (otpResponse.error) {
    throw otpResponse.error;
  }
};

const useEmailLinkForm = (widget: ElemasonAuthEmailLinkFormWidget) => {
  const wData = widget.data!;
  const setStep = useAuthStore((state) => state.setStep);
  const { showToast } = useToast();

  const handleSubmit = async (value: EmailInputFormValue) => {
    const email = value.email!;
    try {
      await sendOtp(email);
      showToast({ title: wData.messages.emailOtpSendSuccess });
      setStep(ElemasonAuthStep.EMAIL_LINK_VERIFICATION, { email });
    } catch (error) {
      Logger.error('useEmailLinkForm:onSubmit', error);
      showToast({ title: getErrorMessage(error, wData.errorMessages) });
    }
  };

  const { isPending: isSubmitting, mutate: onSubmit } = useMutation({
    mutationFn: handleSubmit,
    mutationKey: [],
  });

  return { isSubmitting, onSubmit };
};

export { useEmailLinkForm };
